import React from "react";
import { Box, Button, Card, CardContent, Stack, Typography } from "@mui/material";
import RefreshRoundedIcon from "@mui/icons-material/RefreshRounded";

export default function MonitoringHeader({ title, subtitle, onRefresh, loading }) {
  return (
    <Card
      elevation={0}
      sx={{
        mb: 3,
        borderRadius: 4,
        border: "1px solid #dbe4ea",
        background: "linear-gradient(135deg, #0f2f35 0%, #12424a 100%)",
        color: "#fff",
      }}
    >
      <CardContent sx={{ p: { xs: 2.5, md: 3 } }}>
        <Stack
          direction={{ xs: "column", md: "row" }}
          alignItems={{ xs: "flex-start", md: "center" }}
          justifyContent="space-between"
          spacing={2}
        >
          <Box>
            <Typography variant="h4" sx={{ fontWeight: 800 }}>
              {title}
            </Typography>
            <Typography sx={{ mt: 0.5, color: "rgba(255,255,255,0.82)" }}>
              {subtitle}
            </Typography>
          </Box>

          <Button
            variant="contained"
            startIcon={<RefreshRoundedIcon />}
            onClick={onRefresh}
            disabled={loading}
            sx={{
              bgcolor: "#fff",
              color: "#0f2f35",
              fontWeight: 700,
              "&:hover": { bgcolor: "#f8fafc" },
            }}
          >
            Refresh
          </Button>
        </Stack>
      </CardContent>
    </Card>
  );
}